import PlusIcon from "@heroicons/react/20/solid/PlusIcon";
import { LoadingRing } from "../common/Spinner";
import { ApplicationCard } from "../common/ApplicationCard";
import { usePostHog } from "posthog-js/react";
import { CardSkeleton } from "../common/ProjectBanner";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export function PaginatedApplicationsList(_ref) {
  let {
    applications,
    isLoading,
    isLoadingMore,
    loadNextPage,
    hasMorePages,
    onAddApplicationToCart,
    onRemoveApplicationFromCart,
    applicationExistsInCart
  } = _ref;
  const posthog = usePostHog();
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [applications.map(application => /*#__PURE__*/_jsx(ApplicationCard, {
      application: application,
      inCart: applicationExistsInCart(application),
      onAddToCart: () => {
        posthog.capture("application_added_to_cart", {
          applicationRef: application.applicationRef
        });
        onAddApplicationToCart(application);
      },
      onRemoveFromCart: () => {
        posthog.capture("application_removed_from_cart", {
          applicationRef: application.applicationRef
        });
        onRemoveApplicationFromCart(application);
      }
    }, application.applicationRef)), isLoadingMore && /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(CardSkeleton, {}), /*#__PURE__*/_jsx(CardSkeleton, {}), /*#__PURE__*/_jsx(CardSkeleton, {}), /*#__PURE__*/_jsx(CardSkeleton, {}), /*#__PURE__*/_jsx(CardSkeleton, {})]
    }), !isLoading && hasMorePages && /*#__PURE__*/_jsx("div", {
      className: "flex items-center",
      children: /*#__PURE__*/_jsx("button", {
        className: "rounded-3xl border border-white bg-[#F3F3F5] text-md font-medium px-5 py-3 flex items-center",
        disabled: isLoadingMore,
        onClick: () => loadNextPage(),
        children: isLoadingMore ? /*#__PURE__*/_jsx(LoadingRing, {
          className: "animate-spin w-5 h-5"
        }) : /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(PlusIcon, {
            className: "w-5 h-5 mr-1"
          }), /*#__PURE__*/_jsx("span", {
            children: "Load more"
          })]
        })
      })
    })]
  });
}